import React from 'react';
import { UL } from './elements';
import { 
  PageWrapper,
  Text, 
  Container, 
} from '@Main/elements';
import { P } from '@helpers';

export const Etics = ({t}) => {
  return (
    <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px' paddingBottom='123px' marginRight='69px'>
          <Text width='657px' paddingBefforeText="45px">
            <h1>{t("Content ethics")}</h1>
            <p>
              {t("Based on this position of establishing and building trust in our products, the following ethical tenets apply unquestioningly to content and are not subject to change.")} 
            </p>
          </Text>
          <UL>
            <li>
              <P weight='400' size='15px' height='30px'>
              {t("Soft-FX does not provide untruthful information. The company's specialists in all areas have been working on products and solutions for over a decade, and delivering false data would be a blow to both the self-esteem of our employees and the client's perception.")} 
              </P>
            </li>
            <li>
              <P weight='400' size='15px' height='30px'>
              {t("Soft-FX does not provide unverified information. This requirement stems from the previous one. Unverified information can easily prove to be false.")}
              </P>
            </li>
            <li>
              <P weight='400' size='15px' height='30px'>
              {t("Soft-FX does not use content to disparage competitors. We believe that our development capabilities and the quality of our products are enough to convince the customer that our products and solutions are the right fit for their needs. Content is required to establish this kind of awareness using respectable strategies.")} 
              </P>
            </li>
            <li>
              <P weight='400' size='15px' height='30px'>
              {t("Whenever possible, we use content for educational purposes. With how fast the industry is growing and how much opportunity there is in our domain, we believe players will only benefit by sharing non-sensitive information with each other.")}
              </P>
            </li>
          </UL>
        </Container>
     </PageWrapper>
  );
};